import React, { useEffect, useState, FC } from 'react';
import { Box, Grid, Container } from '@mui/material';
import StyledBox, { StyledFilterDropdown } from 'views/rebranded-module/deals-module/DealsViewV2/DealsViewV2.styles';
import PATHS from 'lib/navigation/paths';
import Head from 'next/head';
import generateMetaData from 'lib/utils/generateMetaData';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';
import useCalculateDealValue from 'views/rebranded-module/common/hooks/useCalculateDealValue';
import { SLUGS_TYPES } from 'lib/utils/CONSTANTS';
import { DEFAULT_DEALS_COUNT } from 'views/deals-module/DealsView/utils/CONSTANTS';
import useRenderAiBot from 'views/common/hooks/useRenderAiBot';
import { PAGES_GA_IDENTIFIERS } from 'views/common/utils/constants';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { HeroSection, PromotedDealSection, PromotedDealSectionSkeleton } from 'views/rebranded-module/deals-module/DealsViewV2/components';
import { RiMapPinLine, RiArrowDownSLine } from 'react-icons/ri';
import { ImgBox, DealCardV2, LazyLoadWithDataCountsV2 } from 'views/rebranded-module/common/components';
import { LazyLoad } from 'views/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';

const DealsViewV2:FC<any> = (props) => {
  const { serverData: data, slugData } = props;
  const cmsData = useContent();
  const getSizedImage = useAdabtiveMultiSizeImage();
  const appNavigator = useAppNavigator();
  const [dealsCount, setDealsCount] = useState(DEFAULT_DEALS_COUNT);
  useRenderAiBot(true);
  const dealValue = useCalculateDealValue();
  const prepareLocationsList = (arrayOfObjects) => {
    const objectNames = arrayOfObjects.map((object) => ({
      id: object.id,
      slug: object.slug,
      name: object.name,
    }));
    const locationsList = [
      {
        id: -1,
        slug: null,
        name: cmsData.DealsListingPage.allLocationsLabel,
      },
      ...objectNames,
    ];
    return locationsList;
  };
  const getFilterList = () => {
    const flitersList = [
      {
        id: 1,
        title: cmsData.DealsListingPage.allLocationsLabel,
        list: prepareLocationsList(data.locations),
        selectedValue: data.selected_location?.name || null,
        type: 'location',
      },
    ];
    return flitersList;
  };
  const handleFilterChange = (e, type) => {
    const { list } = getFilterList().find(
      (filterList) => filterList.type === type,
    );
    const location = list.find((option) => option.name === e.target.value);
    if (location.slug != null) {
      if (
        slugData?.slugs[0].slug_type === SLUGS_TYPES.deal_type_category
        || appNavigator.query.location_slug
      ) {
        appNavigator.push(
          PATHS.motorcycleDeals.typeLocationslug(
            slugData.slugs[0].slug,
            location.slug,
          ),
        );
      } else {
        appNavigator.push(PATHS.motorcycleDeals.slug(location.slug));
      }
    } else if (
      slugData?.slugs[0].slug_type === SLUGS_TYPES.deal_type_category
    ) {
      appNavigator.push(PATHS.motorcycleDeals.slug(slugData?.slugs[0].slug));
    } else {
      appNavigator.push(PATHS.motorcycleDeals.index());
    }
  };
  useEffect(() => {
    window.gtag('event', 'landing_page_view', {
      page_identifier: PAGES_GA_IDENTIFIERS.DEALS_LISTING,
    });
  }, []);

  return (
    <StyledBox>
      {data?.seo_values && <Head>{generateMetaData(data.seo_values)}</Head>}
      <Box>
        <HeroSection
          selectedDealType={data.selected_type?.name}
          selectedLocation={data.selected_location?.name}
          />

      </Box>
      <Box className="DVListAndFilter">
        <Box className="DVBGPattern">
          <ImgBox
            image={{
              src: getSizedImage(cmsData.DealsListingPage.patternBackground),
              alt: cmsData.DealsListingPage.patternBackground.alt,
            }}
            width="100%"
            height="100%"
            unoptimized
                />
        </Box>
        <Container maxWidth="xxl" className="DVFilterAndListContainer DVCustomContainer">
          <Box className="DVFilterDropdownContainer" mb={8}>
            <StyledFilterDropdown
              filterList={getFilterList()[0]}
              handleChange={handleFilterChange}
              icon={<RiMapPinLine className="DVMapIcon" />}
              rightIcon={<RiArrowDownSLine className="DVArrowIcon" />}
            />
          </Box>
          <Box>
            <Grid container rowSpacing={8} columnSpacing={4}>
              {data.deals.slice(0, dealsCount).map((deal) => (
                <Grid
                  item
                  xl={4}
                  lg={6}
                  md={12}
                  xs={12}
                  key={deal.id}
               >
                  <DealCardV2
                    title={deal.title}
                    image={{
                      src: deal.image.medium_url,
                      alt: deal.title,
                    }}
                    link={PATHS.motorcycleDeals.slug(
                      encodeURIComponent(deal.identifier),
                    )}
                    description={deal.description}
                    tagline={deal.tagline}
                    isLargeImage
                    showBtn
                    {...dealValue(
                      deal.value_wc,
                      deal.discounted_price,
                      deal.deal_type.sym_id,
                      { paid_days: deal.paid_days, free_days: deal.free_days },
                    )}
                />
                </Grid>
              ))}
            </Grid>
            <Box my={6}>
              <LazyLoadWithDataCountsV2
                dataCount={dealsCount}
                dataLength={data.deals.length}
                defaultDataCount={DEFAULT_DEALS_COUNT}
                setDataCount={setDealsCount}
          />
            </Box>

          </Box>
        </Container>
      </Box>
      <LazyLoad skeleton={<PromotedDealSectionSkeleton />} dataLoaded>
        <PromotedDealSection />
      </LazyLoad>
    </StyledBox>
  );
};

export { DealsViewV2 };
